import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { send } from "src/utils/fetch";
import { captureException } from "src/utils/error";
import { createAppAsyncThunk } from "../async-thunk";

export interface ActiveSubscriptionDataState {
  hasActiveSubscription: boolean;
  subscriptionId?: string;
  isInTrialPeriod?: boolean;
  planId?: string;
  nextChargeAmount?: number;
  expiryTime?: string;
  activeSubscriptionCurriculumSlug?: string;
  autoRenewalEnabled?: boolean;
  isIAPsubscription?: boolean;
  billingCycleInterval?: string;
  billingCycleIntervalCount?: number;
  accessCode?: string;
  batchId?: number;
}

const activeSubscriptionDataSlice = createSlice({
  name: "activeSubscriptionData",
  initialState: { hasActiveSubscription: false } as ActiveSubscriptionDataState,
  reducers: {
    setActiveSubscriptionData(
      state,
      action: PayloadAction<ActiveSubscriptionDataState>
    ) {
      // Does not support partial updates
      return { ...action.payload };
    },
  },
});

export const { setActiveSubscriptionData } =
  activeSubscriptionDataSlice.actions;

export default activeSubscriptionDataSlice;

const memo: Record<string, Promise<ActiveSubscriptionDataState>> = {};

/**
 * Fetches the active subscription data of an user using the email
 */
export const loadActiveSubscriptionDataState = createAppAsyncThunk(
  "activeSubscriptionData/loadActiveSubscriptionDataState",
  async (email: string, thunkAPI) => {
    if (!memo[email]) {
      const url = `/visitor/api/v1/getVisitorSubscriptionStatus/?email=${encodeURIComponent(
        email
      )}`;

      let activeSubscriptionData = {
        hasActiveSubscription: false,
      };

      memo[email] = send("GET", url)
        .then((data) => {
          activeSubscriptionData = data;
        })
        .catch((e) => {
          captureException(e, "loadActiveSubscriptionDataState");

          // Delete from memo if API call fails so we can retry
          delete memo[email];
        })
        .then(() => {
          thunkAPI.dispatch(setActiveSubscriptionData(activeSubscriptionData));
          return activeSubscriptionData;
        });
    }
    return memo[email];
  }
);
